'use client';

import classNames from 'classnames';
import { ChevronRight } from 'lucide-react';

import { Link } from '@/components/Link/Link';

import styles from './Dropdown.module.scss';

export type Option = {
    active?: boolean;
    class?: string;
    label: string;
    path?: string;
    title?: string;
    id?: string;
    meta?: any;
};

interface Props {
    className?: string;
    triggerClassName?: string;
    triggerTitle: string;
    triggerLabel: string;
    options: Array<Option>;
    onSelect?: (option: Option) => void;
    optionClassName?: string;
    triggerIconClassName?: string;
    optionsClassName?: string;
    hideLabelOnSmall?: boolean;
}

export function Dropdown({
    className,
    options,
    triggerClassName,
    triggerLabel,
    triggerTitle,
    onSelect,
    optionClassName,
    triggerIconClassName,
    optionsClassName,
    hideLabelOnSmall,
}: Props) {
    return (
        <div className={classNames(className, styles.dropdown)}>
            <button
                className={classNames(triggerClassName, styles.trigger)}
                title={triggerTitle}
                onClick={(event) => event.preventDefault()}
            >
                <span className={classNames(styles.label, { [styles.hide]: hideLabelOnSmall })}>
                    {triggerLabel}
                </span>
                <ChevronRight className={classNames(styles.triggerIcon, triggerIconClassName)} />
            </button>

            <div className={styles.menu}>
                <ul className={classNames(styles.options, optionsClassName)}>
                    {options.map((option) => (
                        <li
                            key={option.label}
                            className={classNames(styles.option, {
                                [styles.active]: option.active,
                            })}
                        >
                            <button
                                className={styles.listButton}
                                onClick={() => {
                                    if (onSelect) onSelect(option);
                                }}
                            >
                                {option.path && (
                                    <Link
                                        href={option.path}
                                        className={styles.link}
                                        title={option.title}
                                    >
                                        {option.label}
                                    </Link>
                                )}
                                {option.id && (
                                    <span className={optionClassName}>{option.label}</span>
                                )}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
